import React from 'react';
import { Anchor, Users, Award, Globe } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gray-950">
      <Navbar />
      
      {/* Header */}
      <section className="pt-32 pb-16 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4">
            About Us
          </h1>
          <p className="text-white/70 text-lg max-w-2xl mx-auto">
            Your trusted partner for luxury yacht charters in Southeast Asia
          </p>
        </div>
      </section>

      {/* About Content */}
      <section className="py-16 bg-gray-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            {/* Image */}
            <div className="relative h-[400px] rounded-2xl overflow-hidden">
              <img
                src="https://images.pexels.com/photos/29318860/pexels-photo-29318860.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="CC Yachting"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 to-transparent" />
            </div>

            {/* Text */}
            <div>
              <h2 className="text-3xl font-serif font-bold text-white mb-6">
                Welcome to CC Yachting
              </h2>
              <p className="text-white/70 leading-relaxed mb-6">
                CC Yachting is your premier destination for luxury yacht charter experiences in Southeast Asia. Based in the beautiful island of Phuket, Thailand, we specialize in creating unforgettable maritime adventures across the stunning waters of the Andaman Sea and beyond.
              </p>
              <p className="text-white/70 leading-relaxed mb-6">
                Our carefully curated fleet of world-class yachts, combined with our experienced crew and deep knowledge of the region, ensures that every journey with us is nothing short of extraordinary.
              </p>
              <p className="text-white/70 leading-relaxed">
                Whether you're seeking a romantic getaway, a family adventure, or a corporate retreat, CC Yachting delivers personalized experiences that exceed expectations.
              </p>
            </div>
          </div>

          {/* Values */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="p-6 bg-gray-900/50 rounded-2xl border border-gray-800">
              <div className="w-12 h-12 rounded-xl bg-orange-500/10 flex items-center justify-center mb-4">
                <Anchor className="w-6 h-6 text-orange-500" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Excellence</h3>
              <p className="text-white/60 text-sm">
                We maintain the highest standards in yacht maintenance, service, and guest experience.
              </p>
            </div>
            <div className="p-6 bg-gray-900/50 rounded-2xl border border-gray-800">
              <div className="w-12 h-12 rounded-xl bg-orange-500/10 flex items-center justify-center mb-4">
                <Users className="w-6 h-6 text-orange-500" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Personal Touch</h3>
              <p className="text-white/60 text-sm">
                Every charter is tailored to your unique preferences and desires.
              </p>
            </div>
            <div className="p-6 bg-gray-900/50 rounded-2xl border border-gray-800">
              <div className="w-12 h-12 rounded-xl bg-orange-500/10 flex items-center justify-center mb-4">
                <Award className="w-6 h-6 text-orange-500" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Experience</h3>
              <p className="text-white/60 text-sm">
                Years of expertise in luxury yacht charters across Southeast Asia.
              </p>
            </div>
            <div className="p-6 bg-gray-900/50 rounded-2xl border border-gray-800">
              <div className="w-12 h-12 rounded-xl bg-orange-500/10 flex items-center justify-center mb-4">
                <Globe className="w-6 h-6 text-orange-500" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Local Knowledge</h3>
              <p className="text-white/60 text-sm">
                Deep understanding of the best destinations, hidden gems, and local culture.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
